import "swiper/swiper.min.css";
import { FaArrowLeft, FaArrowRight, FaQuoteRight } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import ClientProfilePicture from "./reusables/ClientProfilePicture";
import React from "react";
import Stars from "../assets/img/portfolio/5stars.svg";

SwiperCore.use([Autoplay, Navigation, Pagination]);

const Testimonials = () => {
	const ImageUrl = [
		{
			imageUrl:
				"https://media.licdn.com/dms/image/C4D03AQFonP1HfHSG6g/profile-displayphoto-shrink_200_200/0/1626813410967?e=1719446400&v=beta&t=vNZGNh-RpBK2nmzDM59eYCVCAwDN_9_lOrOG8m-g4Ao",
			altText: "Adekunle Thompson",
		},
		{
			imageUrl: "https://avatars.githubusercontent.com/u/75146271?v=4",
			altText: "Mr Emmanuel Josiah ",
		},
		{
			imageUrl:
				"https://media.licdn.com/dms/image/D4D03AQE-UckRt11-zQ/profile-displayphoto-shrink_200_200/0/1695575753942?e=1719446400&v=beta&t=PGB9lXqXn5zQlZxxsHDQJAMq7QJJdAWXabe1DeykqS4",
			altText: "Mr Uduehi Anthony ",
		},
		{
			imageUrl:
				"https://media.licdn.com/dms/image/D5616AQHJ2DGuHI8KqA/profile-displaybackgroundimage-shrink_350_1400/0/1676273021711?e=1719446400&v=beta&t=zQ7ZIBEACims7lqWyBJrVidDiydQxLzCPJd09sOjmIQ",
			altText: "Mr Toafeak Olayinka",
		},
	];

	return (
		<div id='Testimonials' className='isolate bg-transparent py-20 sm:py-20'>
			<div className='mx-auto max-w-7xl px-4 lg:px-16'>
				<div className='md:max-w-lg md:pr-10 lg:max-w-lg lg:pr-30'>
					<div className='hidden sm:flex sm:justify-left'>
						<div className='border-b-8 border-gray-900 w-32 my-6'></div>
					</div>
					<p className='mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl text-center sm:text-left'>
						TESTIMONIALS
					</p>
					<p className='mt-6 text-lg leading-8 text-gray-600'>
						What others are saying about my work...
					</p>
				</div>
				<div className=' mt-10 lg:col-span-2 lg:mx-0'>
					<Swiper
						loop
						slidesPerView={1}
						spaceBetween={32}
						autoplay={{ delay: 2500 }}
						breakpoints={{
							640: {
								centeredSlides: true,
								slidesPerView: 1,
							},
							1024: {
								centeredSlides: false,
								slidesPerView: 2,
							},
						}}
						navigation={{
							nextEl: ".next-button",
							prevEl: ".prev-button",
						}}
						slidesPerColumnFill='row'
						className='swiper-container overflow-hidden'>
						<SwiperSlide>
							<blockquote className='flex h-full flex-col bg-gray-200 p-12'>
								<div className='mt-0'>
									<p className='leading-relaxed text-gray-500'>
										Martins was a pleasure to work with. He was very
										professional and knowledgeable, and he always went above and
										beyond to meet my needs. I would definitely recommend him to
										anyone looking for a web developer.
									</p>
									<img
										className='h-4 w-50 object-cover mt-4'
										src={Stars}
										alt='Rating'
									/>
								</div>
								<footer className='mt-6 flex items-center space-x-6 text-sm text-gray-500'>
									<ClientProfilePicture
										imageUrl={ImageUrl[0].imageUrl}
										alt={ImageUrl[0].altText}
									/>
									<span className='flex-grow'>&mdash; Adekunle Thompson</span>
									<FaQuoteRight size={24} />
								</footer>
							</blockquote>
						</SwiperSlide>
						<SwiperSlide>
							<blockquote className='flex h-full flex-col bg-gray-200 p-12'>
								<div className='mt-0'>
									<p className='leading-relaxed text-gray-500'>
										From start to finish, Martins was an absolute pleasure to
										work with. He was always available to answer questions and
										provide updates, and his attention to detail ensured that
										our project was a huge success. I would work with him again
										in a heartbeat.
									</p>
									<img
										className='h-4 w-50 object-cover mt-4'
										src={Stars}
										alt='Rating'
									/>
								</div>
								<footer className='mt-6 flex items-center space-x-6 text-sm text-gray-500'>
									<ClientProfilePicture
										imageUrl={ImageUrl[1].imageUrl}
										alt={ImageUrl[1].altText}
									/>
									<span className='flex-grow'>&mdash; Mr Emmanuel Josiah</span>
									<FaQuoteRight size={24} />
								</footer>
							</blockquote>
						</SwiperSlide>
						<SwiperSlide>
							<blockquote className='flex h-full flex-col justify-between bg-gray-200 p-12'>
								<div className='mt-0'>
									<p className='leading-relaxed text-gray-500'>
										I was impressed by the quality of work Martins did on my
										website. He transformed my vision into a reality, addressing
										my questions and making necessary changes. Highly
										recommended web developer
									</p>
									<img
										className='h-4 w-50 object-cover mt-4'
										src={Stars}
										alt='Rating'
									/>
								</div>
								<footer className='mt-6 flex items-center space-x-6 text-sm text-gray-500'>
									<ClientProfilePicture
										imageUrl={ImageUrl[2].imageUrl}
										alt={ImageUrl[2].altText}
									/>
									<span className='flex-grow'>&mdash; Mr Uduehi Anthony</span>
									<FaQuoteRight size={24} />
								</footer>
							</blockquote>
						</SwiperSlide>
						<SwiperSlide>
							<blockquote className='flex h-full flex-col justify-between bg-gray-200 p-12'>
								<div className='mt-0'>
									<p className='leading-relaxed text-gray-500'>
										I was very happy with the work that Martins did on my
										website. He was able to create a website that was both
										visually appealing and easy to use. I would definitely
										recommend him to anyone looking for a web developer.
									</p>
									<img
										className='h-4 w-50 object-cover mt-4'
										src={Stars}
										alt='Rating'
									/>
								</div>
								<footer className='mt-6 flex items-center space-x-6 text-sm text-gray-500'>
									<ClientProfilePicture
										imageUrl={ImageUrl[3].imageUrl}
										alt={ImageUrl[3].altText}
									/>
									<span className='flex-grow'>&mdash; Mr Toafeak Olayinka</span>
									<FaQuoteRight size={24} />
								</footer>
							</blockquote>
						</SwiperSlide>
					</Swiper>
				</div>
				<div className='mt-8 flex gap-4 items-end justify-end lg:mt-10'>
					<button className='next-button rounded-full border border-gray-900 p-3 text-gray-900 hover:bg-gray-900 hover:text-white'>
						<span className='sr-only'>Previous Slide</span>
						<FaArrowLeft />
					</button>
					<button className='next-button rounded-full border border-gray-900 p-3 text-gray-900 hover:bg-gray-900 hover:text-white'>
						<span className='sr-only'>Next Slide</span>
						<FaArrowRight />
					</button>
				</div>
			</div>
		</div>
	);
};

export default Testimonials;
